import { AnalyticsClient } from './AnalyticsClient'

export default function GoogleTagManagerClient(): AnalyticsClient {
  return {
    track: (event: string, properties?: { [key: string]: any }) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      window &&
        (window as any).dataLayer?.push({
          event,
          ...properties,
        })
    },
  }
}
